function n(n){return!!n&&"function"!=typeof n.subscribe&&"function"==typeof n.then}export{n as isPromise};
